"use strict";


const baseURL = "https://backend-prod.esskayconnect.com/";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.baseURL = baseURL; 